import { Ability } from '@casl/ability'
import { initialAbility } from './initialAbility'

//  Read ability from localStorage
// * Handles auto fetching previous abilities if already logged in user
// ? You can update this if you store user abilities to more secure place
// ! Anyone can update localStorage so be careful and please update this
//const userData = JSON.parse(localStorage.getItem('auth'))
//const existingAbility = userData ? userData.ability : null
let existingAbility = []

const buildAbilityFromUser = userData => {
    if (!userData) return [{ action: 'manage', subject: 'all' }]

    const storedAbility = Array.isArray(userData.ability) ? userData.ability : []
    const hasSafeAbility = storedAbility.some(rule => rule && rule.subject && rule.subject !== 'all')

    if (hasSafeAbility) {
        return storedAbility
    }

    if (userData.isSuperadmin === true) {
        return [
            { action: 'manage', subject: 'bookings' },
            { action: 'manage', subject: 'drivers' },
            { action: 'manage', subject: 'users' },
            { action: 'manage', subject: 'settings' },
            { action: 'manage', subject: 'locations' },
            { action: 'manage', subject: 'logs' },
            { action: 'manage', subject: 'login' }
        ]
    }

    if (userData.userrole === 'Viewer') {
        return [
            { action: 'read', subject: 'bookings' },
            { action: 'manage', subject: 'login' }
        ]
    }

    return [
        { action: 'manage', subject: 'bookings' },
        { action: 'manage', subject: 'drivers' },
        { action: 'manage', subject: 'settings' },
        { action: 'manage', subject: 'locations' },
        { action: 'manage', subject: 'login' }
    ]
}

try {
    const userdata = JSON.parse(localStorage.getItem('auth'))
    existingAbility = buildAbilityFromUser(userdata)
} catch {
    existingAbility = [{ action: 'manage', subject: 'all' }]
}

export default new Ability(existingAbility || initialAbility)
